import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Create analytics addSourceMiddleware fn that stamps each event
 */
export var createConsentStampingMiddleware = function createConsentStampingMiddleware(getCategories) {
  var fn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var payload, next;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload, next = _ref.next;
            _context.t0 = _objectSpread;
            _context.t1 = _objectSpread({}, payload.obj.context.consent);
            _context.t2 = {};
            _context.next = 6;
            return getCategories();
          case 6:
            _context.t3 = _context.sent;
            _context.t4 = {
              categoryPreferences: _context.t3
            };
            payload.obj.context.consent = (0, _context.t0)(_context.t1, _context.t2, _context.t4);
            next(payload);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fn(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return fn;
};